import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { environment } from 'src/environments/environment';
import { EndPoints } from 'src/app/shared/EndPoints';
import { Constants } from 'src/app/shared/constants';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  private customerPortalBaseURL: string;
  private authorizedControlList: any[];

  constructor(private httpService: HttpService,
              private localStorageService: LocalStorageService) {

    this.customerPortalBaseURL = environment.customerPortalServiceUrl;

  }

  /**
   * getAuthorizedControlList method calls GetUIAuthorizeData action method of Authorization Controller and bring the
   * array of list of controls with their authorize property
   */
  public getAuthorizedControlList() {
    return this.httpService.Get<any>(this.customerPortalBaseURL + EndPoints.getUiAuthorizeUrl);
  }

  public hasRequiredPermission(permission: string): boolean {
    const claims = JSON.parse(this.localStorageService.getItem(Constants.CLAIMS));
    const extensionPermissions = this.localStorageService.GetClaimsTransformed(claims.extension_permissions).map((item: string) => item.trim());
    if (extensionPermissions.findIndex((x) => x.toString().toLowerCase() === permission.toLowerCase()) !== -1) {
      return true;
    } else {
      return false;
    }
  }
}
